module.exports = __webpack_public_path__ + "img/professional.e12f1b7c.jpeg";